import STreeList from "@/components/Tree/STreeList";
import { mapState } from "vuex";
export default {
  name: "STreeList",
  components: {
    STreeList
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    increment: {
      type: Number,
      default: 0
    },
    actionTree: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      fold: true,
      poptipVisible: false
    };
  },
  computed: {
    ...mapState(["user"]),
    count() {
      let c = this.increment;
      return c + 1;
    },
    stylePadding() {
      return {
        "padding-left": this.count * 16 + "px"
      };
    },
    isAdmin() {
      return this.user.userInfo.isAdmin === "T";
    }
  },
  methods: {
    stopPropagation(e) {
      e.stopPropagation();
    },
    foldFn(e, item) {
      this.stopPropagation(e);
      item.expand = !item.expand;
    },
    /*
     ** 是否有子项
     */
    haschildren(item) {
      return item.children && item.children.length > 0 ? true : false;
    },
    /*
     ** 选择当前行
     */
    onSelect(item) {
      this.$emit("changeSelect", item);
    },
    /*
     ** 更多
     */
    more(e, item) {
      this.stopPropagation(e);
      console.log(item);
    }
  }
};
//data基本结构
// [{
//   title: "目录",
//   expand: true,
//   check: true,
//   children: [
//     {
//       title: "我的音乐",
//       expand: false,
//       check: false,
//       children: [
//         {
//           title: "周杰伦",
//           expand: false,
//           check: false,
//           children: [
//             {
//               title: "发如雪",
//               expand: false,
//               check: false,
//             },
//           ],
//         },
//         {
//           title: "王杰",
//           expand: false,
//           check: false,
//           children: [
//             {
//               title: "一场游戏一场梦",
//               check: false,
//             },
//           ],
//         },
//       ],
//     },
//     {
//       title: "我的照片",
//       expand: false,
//       check: false,
//     },
//   ],
// }]